/**
 * Message ページのスクロールアニメーション初期化
 */

(function() {
    'use strict';

    /**
     * ヒーローセクションの下向き矢印アイコンクリック時にスクロール
     */
    function initHeroScrollDown() {
        const heroScrollDown = document.querySelector('#message-hero .hero-scroll-down');
        if (!heroScrollDown) {
            return;
        }
        
        // 即座にイベントリスナーを設定（Lenisの初期化を待たない）
        heroScrollDown.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const nextSection = document.querySelector('.message-section');
            if (!nextSection) {
                return;
            }
            
                const headerHeight = document.querySelector('header')?.offsetHeight || 0;
                const additionalOffset = 120;
                const targetPosition = nextSection.offsetTop - headerHeight + additionalOffset;
                
            // Lenisが利用可能な場合はLenisを使用、そうでなければ通常のscrollTo
            if (window.lenis) {
                window.lenis.scrollTo(targetPosition, {
                    duration: 1.2,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    offset: 0
                });
            } else {
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    }

    /**
     * ページ初期化
     */
    function initMessagePage() {
        initHeroScrollDown();
        // AOS初期化はaos-init.jsで行われるため、ここでは何もしない
    }

    // DOMContentLoadedで確実に実行
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initMessagePage);
        } else {
            initMessagePage();
    }
})();
